import { resolveImageAlt } from '@eliadmin/core/src/utils/image-alt-utils';
import type { GeneralLayout } from '@eliadmin/core/src/api/general/types/general-layout-types';
import { ROUTES } from '@eliadmin/core/src/constants/routes';
import { cn } from '@eliadmin/core/src/utils/style-utils';
import Image from '@eliadmin/core/src/components/image/image-wrapped';
import Link from '@eliadmin/core/src/components/link';

export type HeaderLogoProps = {
  generalLayout: GeneralLayout['data'];
};

export function HeaderLogo({ generalLayout }: HeaderLogoProps) {
  return (
    <Link
      href={ROUTES.HOME() ?? '#'}
      className={cn(
        'flex h-[90px] w-[202px] items-center justify-center overflow-visible',
        'ea-header-logo',
      )}
      prefetch={false}
    >
      {generalLayout.header.logo ? (
        <Image
          src={generalLayout.header.logo.url}
          alt={resolveImageAlt(generalLayout?.header?.logo, undefined)}
          width="0"
          height="0"
          sizes="100vw"
          className={cn(
            'min-h-[120px] min-w-[250px]', // Allow the image to overflow on Y axis
            'ea-header-logo__image',
          )}
        />
      ) : (
        <div data-ea-visual-tag="h1" className={cn('text-2xl font-bold', 'ea-header-logo__text')}>
          {generalLayout.site_name?.trim() || ''}
        </div>
      )}
    </Link>
  );
}
